export default __webpack_public_path__ + "static/kn-footer-logo-a1237df8afe81f2fbc7748a073ce4ae6.png";